import React from 'react';

const useCollapseAnimation = (collapseElementClassName: string, defaultIsOpen: boolean = true) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(defaultIsOpen);
  const toggleCollapse = React.useCallback((state) => {
    setIsOpen(typeof state === 'boolean' ? state : (old) => !old);
    setIsHover(false);
  }, []);

  const [isHover, setIsHover] = React.useState<boolean>(defaultIsOpen);

  const handleOnMouseEnter = React.useCallback((e: MouseEvent) => {
    const clickIcon = document.getElementsByClassName(collapseElementClassName)[0];

    if (!clickIcon || (e?.target instanceof Node && e.target === clickIcon)) {
      // Don't set hover if user hovered click icon
      return;
    }

    setIsHover(true);
  }, []);
  const handleOnMouseLeave = React.useCallback(() => {
    setIsHover(false);
  }, []);

  return {
    isOpen,
    toggleCollapse,
    isHover,
    handleOnMouseEnter,
    handleOnMouseLeave,
  };
};

export default useCollapseAnimation;
